import React from "react";

const Pagination = ({
  currentPage,
  totalPages,
  onPageChange,
  className = "",
}) => {
  if (totalPages <= 1) return null;

  return (
    <div className={`flex items-center justify-center ${className}`}>
      <button
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
        className="px-3 py-1.5 text-gray-600 hover:text-gray-900 disabled:opacity-40"
        aria-label="Previous page"
      >
        ←
      </button>

      <div className="mx-3 flex items-center">
        <span className="text-sm text-gray-700 mr-2">Page</span>
        <span className="font-medium text-blue-600 mr-1">{currentPage}</span>
        <span className="text-sm text-gray-500">/ {totalPages}</span>
      </div>

      <button
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        className="px-3 py-1.5 text-gray-600 hover:text-gray-900 disabled:opacity-40"
        aria-label="Next page"
      >
        →
      </button>
    </div>
  );
};

export default Pagination;